appConfig.getModule('translations')
    .factory('translationsService', ['$http', '$q', '$filter', '$rootScope', 'SERVICE_CALL', 'commonService', 'Upload',
        function ($http, $q, $filter, $rootScope, SERVICE_CALL, commonService, Upload) {

           var translationsService = {};

            translationsService.getLanguageList = function (data) {

                var deferred = $q.defer();

                $http(commonService.createHttpRequestObject(SERVICE_CALL.translations.getLanguageList, data))
                    .success(function (res) {

                        if (res.success) {
                            deferred.resolve(res.data);
                        } else {
                            deferred.reject(res.err);
                        }
                    })
                return deferred.promise;
            }

            translationsService.getLanguageKeys = function (data) {

                var deferred = $q.defer();

                $http(commonService.createHttpRequestObject(SERVICE_CALL.translations.getLanguageKeys, data))
                    .success(function (res) {

                        if (res.success) {
                            deferred.resolve(res.data);
                        } else {
                            deferred.reject(res.err);
                        }
                    })
                return deferred.promise;
            }

            translationsService.getTranslationDetails = function (data) {

                var deferred = $q.defer();

                $http(commonService.createHttpRequestObject(SERVICE_CALL.translations.getTranslationDetails, data))
                    .success(function (res) {

                        if (res.success) {
                            deferred.resolve(res.data);
                        } else {
                            deferred.reject(res.err);
                        }
                    })
                return deferred.promise;
            }

            translationsService.deleteLanguageKey = function (data) {

                var deferred = $q.defer();
                $http(commonService.createHttpRequestObject(SERVICE_CALL.translations.deleteLanguageKey, data))
                    .success(function (res) {
                        if (res.success) {
                            deferred.resolve(res.success);
                        } else {
                            deferred.reject(res.err);
                        }
                    })
                return deferred.promise;
            }

            translationsService.saveTranslation = function (data) {

                var deferred = $q.defer();
                $http(commonService.createHttpRequestObject(SERVICE_CALL.translations.saveTranslation, data))
                    .success(function (res) {
                        if (res.success) {
                            deferred.resolve(res.success);
                        } else {
                            deferred.reject(res.err);
                        }
                    })
                return deferred.promise;

            }

            translationsService.compileLanguage = function (data) {

                var deferred = $q.defer();
                $http(commonService.createHttpRequestObject(SERVICE_CALL.translations.compileLanguage, data))
                    .success(function (res) {
                        if (res.success) {
                            deferred.resolve(res.success);
                        } else {
                            deferred.reject(res.err);
                        }
                    })
                return deferred.promise;

            }

            translationsService.getExportUrl = function () {

                var deferred = $q.defer();
                $http(commonService.createHttpRequestObject(SERVICE_CALL.translations.getExportUrl))
                    .success(function (res) {
                        if (res.success) {
                            deferred.resolve(res.data);
                        } else {
                            deferred.reject(res.err);
                        }

                    })
                return deferred.promise;

            }

            translationsService.getUserSelectedLanguage = function (key='translation') {

                var currentTranslationObj = commonService.localStorage.getKeyValue(key, false);

                return currentTranslationObj ? (currentTranslationObj.langCode || '') : '';

            }

            translationsService.setUserSelectedLanguage = function (langCode, langDir,key='translation') {

                var currentTranslationObj = commonService.localStorage.getKeyValue(key, false);

                if (currentTranslationObj) {
                    currentTranslationObj['langCode'] = langCode;
                    currentTranslationObj['langDir'] = langDir;
                } else {
                    currentTranslationObj = {
                        langCode: langCode,
                        langDir: langDir
                    }
                }

                commonService.localStorage.setKeyValue(key, currentTranslationObj);

            }

            translationsService.getDefaultLanguage = function () {

                var deferred = $q.defer();

                $http(commonService.createHttpRequestObject(SERVICE_CALL.translations.getDefaultLanguage))
                    .success(function (res) {
                        if (res.success) {
                            deferred.resolve(res.data);
                        } else {
                            deferred.reject(res.err);
                        }

                    })

                return deferred.promise;

            }

            translationsService.setTranslationStrings = function (langCode, langDir,key='translation') {

                var deferred = $q.defer();

                var currentTranslationObj = commonService.localStorage.getKeyValue(key, false);

                var translationVersion;

                if (currentTranslationObj) {
                    if (langCode == currentTranslationObj.langCode) {
                        translationVersion = currentTranslationObj.version || '';
                    } else {
                        translationVersion = '';
                    }
                    // Issue came that when you refresh the Preview URL then builder language was getting changed by Preview langugae
                    // Fix: If the key name is translation and lang cod eis already in cache
                    // Then use the same languga ecode since translation key is for builder
                    if(currentTranslationObj.langCode && key == 'translation') {
                        langCode = currentTranslationObj.langCode;
                    }
                }

                $http(commonService.createHttpRequestObject(SERVICE_CALL.translations.getTranslationStrings, {
                    langCode: langCode,
                    version: translationVersion
                })).success(function (res) {
                    if (res.success) {
                        // if is not recent update the value else resolved.
                        if (!res.isRecent && !res.data.isRecent) {
                            var data = {
                                version: res.data.version,
                                langCode: langCode,
                                translationObj: res.data.readPublishedLang || {},
                                langDir: langDir
                            }
                            commonService.localStorage.setKeyValue(key, data);
                            $rootScope.currentTranslationObj = data.translationObj;
                        }

                        deferred.resolve();
                    } else {
                        deferred.reject(res.err);
                    }

                })

                return deferred.promise;

            }

            translationsService.getTranslatedKey = function (key) {
                // if(key == 'INDICATOR')
                // console.log(key);

                var value = key;

                if (!$rootScope.currentTranslationObj) {
                    var translation = commonService.localStorage.getKeyValue('translation', false);
                    if (angular.copy(translation)) {
                        
                        $rootScope.currentTranslationObj = translation.translationObj;
                        
                    } else {
                        $rootScope.currentTranslationObj = {};
                    }
                }
                // if(key == 'INDICATOR')
                // console.log(angular.copy($rootScope.currentTranslationObj));
                value = $rootScope.currentTranslationObj[key] || value;
                // console.log(value);
                return value;

            }

            translationsService.importTranslationFile = function (data) {
                // var deferred = $q.defer();

                // $http(commonService.createHttpRequestObject(SERVICE_CALL.translations.getDefaultLanguage))
                //     .success(function (res) {
                //         if (res.success) {
                //             deferred.resolve(res.data);
                //         } else {
                //             deferred.reject(res.err);
                //         }

                //     })

                // return deferred.promise;

                return Upload.upload({
                    url: commonService.createServiceCallUrl(SERVICE_CALL.translations.importFile),
                    data: data,
                    method: 'POST'
                });
            }

            return translationsService;

        }
    ])
